export const ALGOLIA_FACETS = {
  TO: ' TO ',
  SORT_PRICE_GUEST: 'sortPrice_Guest',
  HINGE_DISTANCE: 'attributes_translated.HINGE_DISTANCE',
  MIN: 'min',
  MAX: 'max',
}
export const ALGOLIA_TRACKING = 'algoliaTracking'
export const ENCODED_COLON = '%3A'
export const PRODUCTS_QUERYID = 'productsQueryID'
